import { getGameConfig } from '../../../shared/gameConfig';
import { IRetailGameConfig } from '../../../shared/gameConfig/wowretail/types';

export const gameConfig = getGameConfig<IRetailGameConfig>();
